<script lang="ts" setup>
	import {getProductDetailUrl} from '@/api/api';
	import IconComponent from '@/components/generic/IconComponent.vue';
	import FavoriteProductButton from '@/components/table/producttable/FavoriteProductButton.vue';
	import {useRegionStore} from '@/store/region.store';
	import type {Product} from 'dummen-shared';
	import {computed} from 'vue';

	const props = defineProps<{
		product: Product;
	}>();

	const getDetailUrl = computed(() => {
		const selectedRegion = useRegionStore().getSelectedRegionUrlName();
		const {urlFriendlyId, urlFriendlyName, urlFriendlyProductgroup} = props.product;

		return getProductDetailUrl(selectedRegion, urlFriendlyId, urlFriendlyName, urlFriendlyProductgroup);
	});

	const getGridFields = computed(() => {
		return props.product.fields.filter(field => field.showInTile);
	});

</script>

<template>
	<article class="product-grid-item">
		<a :href="getDetailUrl" class="product-grid-item__image">
			<template v-if="product.tileimage">
				<img data-pagespeed-no-transform
				     height="270"
				     sizes="(min-width: 640px) 270px, 65px"
				     :src="product.tileimage"
				     width="270" />
			</template>
			<template v-else>
				<img data-pagespeed-no-transform
				     height="270"
				     src="/assets/images/build/fallback-product-image.jpg"
				     width="270" />
			</template>
		</a>

		<div class="product-grid-item__info">
			<h2 class="product-grid-item__name">
				<a :href="getDetailUrl">
					{{ product.name }}
					<span v-if="product.focus" class="label--new">{{ product.focus }}</span>
				</a>
			</h2>

			<div class="product-grid-item__group">
				{{ product.gridSubtitle }}
			</div>

			<ul class="product-grid-item__details">
				<li v-for="(field) in getGridFields" :key="field.key" :data-column="field.key">
					<template v-if="field.showInTile">
						<template v-if="field.icon || field.iconStyle">
							<span v-if="field.icon" :title="field.title">
					            <IconComponent
							            :alternate-text="field.content"
							            :name="field.icon"
							            :type="field.key"
							            extension="svg" />
							</span>

							<span v-if="field.iconStyle" :title="field.title">
					            <span :style="field.iconStyle" class="icon-color"></span>
							</span>
						</template>

						<span v-else class="catalog-overview-table__cell-content">
							<span v-html="field.content" />
						</span>
					</template>
				</li>
			</ul>

			<div class="product-grid-item__favorite">
				<FavoriteProductButton :product-id="product.id" />
			</div>
		</div>
	</article>
</template>
